<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-sm-12">
          <div class="element-box mb-0">
            <h5 class="form-header">Reporte Lista de Pedidos</h5>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <TiendaSelectComponent :current="current" />
                  <ClientesSelectComponent :current="current" />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input
                    required
                    type="date"
                    class="form-control"
                    v-model="current.fecha_inicio"
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input
                    required
                    type="date"
                    class="form-control"
                    v-model="current.fecha_fin"
                  />
                </div>
              </div>
              <button
                v-if="current.fecha_inicio && current.fecha_fin"
                @click="imprimir(current)"
                class="btn btn-success btn-sm btn-block"
              >
                <span>Generar en PDF</span>
              </button>
            </div>
            <div class="form-buttons-w">
              <button
                class="btn btn-md btn-secondary"
                @click="refreshDataDefault"
              >
                Limpiar Datos
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Notifications from "@/notifications/notifications";
import ClientesSelectComponent from "@/components/commons/ClientesSelectComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    ClientesSelectComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      current: {
        fecha_final: null,
        fecha_inicial: null,
        cliente_nit: "",
        solo_con_saldo: "",
        errors: {
          cliente_nit: "",
        },
      },
      datos: "",
    };
  },
  methods: {
    refreshDataDefault() {
      let self = this;
      self.current.cliente_nit = "";
      self.current.fecha_fin = "";
      self.current.fecha_inicio = "";
      self.current.solo_con_saldo = "";
      self.datos = "";
      self.current.tienda = "";
    },
    imprimir(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      if (!current.tienda && !current.cliente_nit) {
        window.open(
          `${baseApiUrl}/cat/reporte/?report_name=cxc/pedidos/ventas_pedidos.jrxml&fecha_inicio=${current.fecha_inicio}&fecha_fin=${current.fecha_fin}`
        );
        return;
      }
      if (!current.tienda) {
        window.open(
          `${baseApiUrl}/cat/reporte/?report_name=cxc/pedidos/ventas_pedidos.jrxml&fecha_inicio=${current.fecha_inicio}&fecha_fin=${current.fecha_fin}&cliente_nit=${current.cliente_nit}`
        );
        return;
      }
      if (!current.cliente_nit) {
        window.open(
          `${baseApiUrl}/cat/reporte/?report_name=cxc/pedidos/ventas_pedidos.jrxml&fecha_inicio=${current.fecha_inicio}&fecha_fin=${current.fecha_fin}&tiendaid=${current.tienda}`
        );
        return;
      }
      window.open(
        `${baseApiUrl}/cat/reporte/?report_name=cxc/pedidos/ventas_pedidos.jrxml&fecha_inicio=${current.fecha_inicio}&fecha_fin=${current.fecha_fin}&cliente_nit=${current.cliente_nit.nit}&tiendaid=${current.tienda}`
      );
    },
  },
};
</script>
